import React from 'react'

export default function Advertise() {
  return (
    <div>
      Advertise
    </div>
  )
}
